<template>
    <div v-if="weekStat.length !== 0" class="endWeekWidget"> 
        <div>
           <weekReport :weekData="weekStat"/>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import weekReport from '../chartsForTabs/profitWeekCharts/reportForWeek'
export default {
    components: {
        weekReport
    },
    data() {
        return {
            weekStat:[]
        }
    },
    computed: {
       ...mapGetters(
           {
               getMonthStat: 'accountstat/getYearStat'
           }
       )
    },
    methods: {
        updateChart() {
            let stat = this.getMonthStat('', new Date(), null);
            if(!stat.week || !stat || stat.week.length === 0) {
                return
            }
            this.weekStat = stat.week[stat.week.length - 1];
            //this.lastWeeks  = this.weekSum.week.slice(this.weekSum.week.length - 4);
        },
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.updateChart() 
        });
        this.updateChart();
    }
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "endWeekWidget",
            handler: handler
        }
    });
}

</script>